module.exports = __webpack_public_path__ + "static/auto_insurance_info.08147a42.pdf";


//////////////////
// WEBPACK FOOTER
// ./src/documents/auto_insurance_info.pdf
// module id = 316
// module chunks = 140389645284302